// Show accordion
var show = function (elem) {
  // Get the natural height of the element
  var getHeight = function () {
    elem.style.display = 'block';
    var height = elem.scrollHeight + 'px';
    //  Hide it again
    elem.style.display = '';
    return height;
  };

  var height = getHeight();
  elem.parentElement.classList.add('active');
  elem.parentElement.classList.remove('closing');
  elem.style.height = height;

  // Once the transition is complete, remove the inline max-height so the content can scale responsively
  window.setTimeout(function () {
    elem.style.height = '';
  }, 350);
};

// Hide accordion
var hide = function (elem) {
  // Give the element a height to change from
  elem.style.height = elem.scrollHeight + 'px';

  // Set the height back to 0
  window.setTimeout(function () {
    elem.style.height = '0';
  }, 1);

  elem.parentElement.classList.add('closing');

  // When the transition is complete, hide it
  window.setTimeout(function () {
    elem.parentElement.classList.remove('active');
    elem.parentElement.classList.remove('closing');
  }, 350);
};

// Toggle accordion
var toggle = function (elem, timing) {
  // If the element is visible, hide it
  if (elem.parentElement.classList.contains('active')) {
    hide(elem);
    return;
  }

  // Otherwise, show it
  show(elem);

  // Hide rest of sibling toggles
  const currentToggle = elem.parentNode;

  let siblings;

  if (currentToggle.parentNode.classList.contains('compare-item')) {
    siblings = Array.from(currentToggle.closest('ul').querySelectorAll('.accordion-item')).filter(function (sibling) {
      return sibling !== currentToggle;
    });
  } else {
    siblings = Array.from(currentToggle.parentNode.children).filter(function (sibling) {
      return sibling !== currentToggle;
    });
  }

  siblings.forEach((sibling) => {
    if (sibling.classList.contains('toggle-item')) {
      hide(sibling.querySelector('.toggle-content'));
    } else {
      hide(sibling.querySelector('.accordion-content'));
    }
  });
};
